import { buildService } from './decorated-service';
import settings from '../../../settings.json';

const api = buildService('/nasu-svc/service');
const errorCodes = [204, 404, 403, 500];

export const mockedRPSPlanInfo = {
  planNumber: '805204',
  planName: 'HARRIS TEETER SUPERMARKE(MASKED) RETIREMENT AND SAVINGS PLAN',
  fundsInPlan: [
    {
      productShortName: 'DMG',
      productLongName: 'MID-CAP GROWTH FUND',
      productAbbrev: 'DMG',
      trpFund: true,
      retailFundInfo: {
        name: 'T. Rowe Price Mid-Cap Growth Fund',
        shortName: 'Mid-Cap Growth Fund',
        ticker: 'RPMGX',
        trpCode: 'DMG'
      }
    },
    {
      productShortName: 'BCG',
      productLongName: 'Blue Chip Growth',
      productAbbrev: 'BCG',
      trpFund: true,
      retailFundInfo: {
        name: 'T. Rowe Price Blue Chip Growth',
        shortName: 'Blue Chip Growth Fund',
        ticker: 'TRBCX',
        trpCode: 'BCG'
      }
    },
    {
      productShortName: 'MTF',
      productLongName: 'Communications & Technology FUND',
      productAbbrev: 'MTF',
      trpFund: true,
      retailFundInfo: {
        name: 'T. Rowe Price Communications & Technology Fund',
        shortName: 'Communications & Technology',
        ticker: 'PRMTX',
        trpCode: 'MTF'
      }
    },
    {
      productShortName: 'TSVF2',
      productLongName: 'STABLE VALUE COMMON TR - F',
      productAbbrev: 'TSVF2',
      trpFund: false,
      retailFundInfo: null
    }
  ]
};

export const mockedRPSPlans = {
  taxID: '916927501',
  taxIDType: 'SSN',
  planNumbers: ['805204', '809657']
};

export const getRPSPlans = async (businessPartyId): Promise<any> => {
  if (settings['mockedMode']) return mockedRPSPlans;

  const payload = businessPartyId && { businessPartyId };

  return api.http.post('/ocr-customer/rps-plans', payload, { errorCodes });
};

export const getRPSPlansBySSN = async (rpsSSN): Promise<any> => {
  const payload = rpsSSN && { ssn: rpsSSN };

  return api.http.post('/ocr-customer/rps-plans-by-ssn', payload, {
    errorCodes
  });
};

export const updateRPSCustomerSSN = async (
  businessPartyId,
  ssn
): Promise<any> => {
  const payload = { ssn, businessPartyId };

  return api.http.post('/ocr-customer/update-customer-ssn', payload, {
    errorCodes
  });
};

export const getRPSPlanInfo = async (ssn, planNumber): Promise<any> => {
  if (settings['mockedMode']) return mockedRPSPlanInfo;
  const payload = {
    ssn,
    planNumber
  };

  return api.http.post('/ocr-customer/rps-plan-info', payload, {
    errorCodes,
    ignoreServiceFailure: true
  });
};
